// routes/dashboard.routes.tsx
import { lazy } from 'react';
// import Protected from './Protected';
const Protected = lazy(() => import('./Protected'));
const DashboardLayout = lazy(() => import('../components/Layouts/DashboardLayout'));
// import SlideTransition from '../components/animation/transition/SlideTransition';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
const SlideTransition = lazy(() => import('../components/animation/transition/SlideTransition'));

// Lazy-loaded components
const ComingSoonPage = lazy(() => import('../pages/info/ComingSoonPage'));
const EditListingPage = lazy(() => import('../pages/EditListingPage'));
const VerifyProfile = lazy(() => import('../components/dashboard/VerifyProfile'));
const DashboardHomePage = lazy(() => import('../pages/DashboardHomePage'));
const LoginAndSecurityPage = lazy(() => import('../pages/LoginAndSecurityPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const DeleteAccount = lazy(() => import('../components/dashboard/DeleteAccount'));
const Notifications = lazy(() => import('../components/dashboard/Notifications'));
const CreatedSuccessfully = lazy(() => import('../components/steps/CreatedSuccessfully'));
const LeadSubmittedSuccessPage = lazy(
  () => import('../components/huntingBoard.tsx/LeadSubmittedSuccessPage')
);
const ListMatchesPerHunt = lazy(
  () => import('../components/huntingBoard.tsx/dashboard/ListMatchesPerHunt')
);
const HuntCreatedSuccessPage = lazy(
  () => import('../components/huntingBoard.tsx/HuntCreatedSuccessPage')
);
const HuntingDashboard = lazy(
  () => import('../components/huntingBoard.tsx/dashboard/HuntingDashboard')
);
const MatchesPerHunt = lazy(
  () => import('../components/huntingBoard.tsx/dashboard/MatchesPerHunt')
);
const AddBusiness = lazy(() => import('../pages/business/AddBusiness'));
const NotificationPage = lazy(() => import('../pages/NotificationPage'));
// const AddPost = lazy(() => import('../pages/square/AddPost'));

const AddPost = lazy(() => {
  console.log('👉 AddPost is being loaded');
  return import('../pages/square/AddPost');
});

const ManageListingPage = lazy(() => import('../pages/ManageListingPage'));
const BillingPayment = lazy(() => import('../components/main/payment/BillingPayment'));

export const dashboardRoutes = [
  {
    element: <DashboardLayout />,
    children: [
      {
        path: '/users/dashboard',
        element: (
          <Protected>
            <SlideTransition direction="ltr">
              <DashboardHomePage />
            </SlideTransition>
          </Protected>
        ),
      },
      {
        path: '/users/addbusiness',
        element: (
          <Protected>
            <AddBusiness />
          </Protected>
        ),
      },
      {
        path: '/users/addpost/:type',
        element: (
          <Protected>
            <AddPost />
          </Protected>
        ),
      },
      {
        path: '/users/verifyprofile',
        element: (
          <Protected>
            <VerifyProfile />
          </Protected>
        ),
      },
      {
        path: '/users/deleteaccount',
        element: (
          <Protected>
            <DeleteAccount />
          </Protected>
        ),
      },
      {
        path: '/users/manage-listings',
        element: (
          <Protected>
            <SlideTransition>
              <ManageListingPage />
            </SlideTransition>
          </Protected>
        ),
      },
      {
        path: '/users/loginandsecurity',
        element: (
          <Protected>
            <SlideTransition>
              <LoginAndSecurityPage />
            </SlideTransition>
          </Protected>
        ),
      },
      {
        path: '/users/notifications',
        element: (
          <Protected>
            <Notifications />
          </Protected>
        ),
      },
      {
        path: '/property-created/:type?',
        element: (
          <Protected>
            <CreatedSuccessfully />
          </Protected>
        ),
      },
      {
        path: '/users/profile',
        element: (
          <Protected>
            <SlideTransition>
              <ProfilePage />
            </SlideTransition>
          </Protected>
        ),
      },
      {
        path: '/notifications',
        element: (
          <Protected>
            <NotificationPage />
          </Protected>
        ),
      },
      {
        path: '/users/edit-listing/:id',
        element: (
          <Protected>
            <EditListingPage />
          </Protected>
        ),
      },
      {
        path: '/users/billing-payment',
        element: (
          <Protected>
            <BillingPayment />
          </Protected>
        ),
      },
      {
        path: '/comingsoon',
        element: (
          <Protected>
            <ComingSoonPage />
          </Protected>
        ),
      },
      {
        path: '/hunting-board/leadsubmitted/:type',
        element: (
          <Protected>
            <LeadSubmittedSuccessPage />
          </Protected>
        ),
      },
      {
        path: '/hunting-board/huntcreated/:type',
        element: (
          <Protected>
            <HuntCreatedSuccessPage />
          </Protected>
        ),
      },
      {
        path: '/hunting-board/dashboard/:type/:tab?',
        element: (
          <Protected>
            <SlideTransition>
              <HuntingDashboard />
            </SlideTransition>
          </Protected>
        ),
      },
      {
        path: '/hunting-board/matches/hunt/:type/:id',
        element: (
          <Protected>
            <MatchesPerHunt />
          </Protected>
        ),
      },
      {
        path: '/hunting-board/leads/hunt/:type/:id',
        element: (
          <Protected>
            <ListMatchesPerHunt />
          </Protected>
        ),
      },
    ],
  },
];
